<!-- Texty k vrstvě -->
<template>
  <div>
    <details
      v-show="layer.isActive || layer.activeSublayersCounter > 0"
      @toggle="detailsClicked([$event, layer.id])"
      v-bind:open="isOpen(layer.id)"
      v-bind:class="{
        invisible: (layer.isActive && layer.opacity == 0) || !layer.isActive
      }"
    >
      <summary v-if="layer.isHighlight">
        <b>{{ layer.name }}</b>
        <span v-if="layer.view">
          <a :href="layer.view">Pohled</a> |
          <LayerPrintButton :layer="layer" />
        </span>
        <i v-if="layer.id in commentsCount">
          | Komentářů: {{ commentsCount[layer.id] }}
        </i>
      </summary>
      <summary v-else>
        {{ layer.name }}
        <span v-if="layer.view">
          <a :href="layer.view">Pohled</a> |
          <LayerPrintButton :layer="layer" />
        </span>
        <i v-if="layer.id in commentsCount">
          | Komentářů: {{ commentsCount[layer.id] }}
        </i>
      </summary>

      <button
        @click="openCol(layer.id)"
        v-show="canDisplayCaptionButton(layer.id)"
      >
        Legenda =>
      </button>
      &nbsp;&nbsp;
      <div v-html="layer.text" v-show="layer.isActive"></div>

      <LayerTextComments
        v-if="general.user.permissions.canAddComments && layer.isActive"
        :layer="layer"
        v-on:comments-loaded="handleCommentsLoaded"
      />

      <details
        v-for="subLayerId in subLayers"
        :key="subLayerId"
        v-show="layers.layers[subLayerId].isActive"
        @toggle="detailsClicked([$event, subLayerId])"
        v-bind:open="isOpen(subLayerId)"
        v-bind:class="{
          invisible:
            layers.layers[subLayerId].isActive &&
            layers.layers[subLayerId].opacity == 0
        }"
      >
        <summary>
          {{ layers.layers[subLayerId].name }}

          <span v-if="layers.layers[subLayerId].view">
            <a :href="layers.layers[subLayerId].view">Pohled</a> |
            <LayerPrintButton :layer="layers.layers[subLayerId]" />
          </span>
          <i v-if="subLayerId in commentsCount">
            | Komentářů: {{ commentsCount[subLayerId] }}
          </i>
        </summary>
        <button
          @click="openCol(layer.id, subLayerId)"
          v-show="
            canDisplayCaptionButton(subLayerId) ||
            canDisplayCaptionButton(layer.id)
          "
        >
          Legenda =>
        </button>
        <div v-html="layers.layers[subLayerId].text"></div>

        <LayerTextComments
          v-if="
            general.user.permissions.canAddComments &&
            layers.layers[subLayerId].isActive
          "
          :layer="layers.layers[subLayerId]"
          v-on:comments-loaded="handleCommentsLoaded"
        />
      </details>
    </details>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import LayerPrintButton from '@/components/sidebar/LayerPrintButton';
import LayerTextComments from '@/components/LayerTextComments';
import Vue from 'vue';

export default {
  props: {
    layer: {
      type: Object,
      required: true
    },
    subLayers: {
      type: Array
    },
    openedLayers: {
      type: Array
    }
  },
  data() {
    return {
      commentsCount: {}
    };
  },
  computed: {
    ...mapState(['general', 'layers']),
    ...mapActions(['general/setLayoutOption'])
  },
  components: {
    LayerPrintButton,
    LayerTextComments
  },
  mounted: function () {
    if (document.addEventListener)
      document.addEventListener('click', this.linkClick, false);
    else document.attachEvent('onclick', this.linkClick);

    this.commentsCount[123] = 123;

    // // Get comments for this layer + all sublayers
    // let allLayerIds = this.subLayers ? this.subLayers : [];
    // allLayerIds.push(this.layer.id);
    // CommentService.getCommentsByIds(JSON.stringify(allLayerIds))
    //   .then((result) => {
    //     if (result.data) {
    //       console.log(result.data, 'getCommentsByIds');
    //       this.comments = result.data;
    //     }
    //   })
    //   .catch(() => {});
  },
  methods: {
    linkClick(e) {
      e = window.e || e;

      if (e.target.tagName !== 'A') {
        return;
      }

      if (e.target.target === '_self') {
        return;
      }

      if (e.target.target != '_blank' && e.target.href) {
        window.location = e.target.href;
        window.location.reload(true);
      }
    },
    canDisplayCaptionButton(layerId) {
      return (
        !this.general.layout.sidebarLeft ||
        !JSON.parse(this.$route.params.openSettings).includes(layerId)
      );
    },
    openCol(parentId, layerId = undefined) {
      this.$store.dispatch('general/setLayoutOption', ['sidebarLeft', true]);
      this.$store.dispatch('general/setLayoutOption', ['sidebarRight', false]);

      // Update URL
      if (this.isOpen(parentId)) {
        if (layerId) {
          this.$store.dispatch(
            'general/setOpenSettings',
            `[${parentId}, ${layerId}]`
          );
        } else {
          this.$store.dispatch('general/setOpenSettings', `[${parentId}]`);
        }
      }
    },
    isOpen(layerId) {
      if (this.openedLayers) {
        let index = this.openedLayers.indexOf(layerId);

        if (index > -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    detailsClicked([event, layerId]) {
      let openStatus = event.target.getAttribute('open');

      let obj = {
        ...this.$route.params
      };
      let openSettings = JSON.parse(obj['openTexts']);

      var index = openSettings.indexOf(layerId);

      if (openStatus !== null) {
        if (index == -1) {
          openSettings.push(layerId);
        }
      } else {
        if (index > -1) {
          openSettings.splice(index, 1);
        }
      }

      obj['openTexts'] = JSON.stringify(openSettings);

      this.$router.replace({ name: 'base', params: obj }).catch((err) => {});
    },
    handleCommentsLoaded(ev) {
      Vue.set(this.commentsCount, ev.id, ev.count);
      // this.commentsCount[ev.id] = ev.count;
      console.log(this.commentsCount, 'c c2');
    }
  }
};
</script>

<style scoped>
details.invisible {
  background-color: #f4f6f7;
}

details.invisible > summary {
  opacity: 0.5;
}
</style>
